import { render, staticRenderFns } from "./MarzipanoMinimap.vue?vue&type=template&id=212b4e28&scoped=true&"
import script from "./MarzipanoMinimap.vue?vue&type=script&lang=js&"
export * from "./MarzipanoMinimap.vue?vue&type=script&lang=js&"
import style0 from "./MarzipanoMinimap.vue?vue&type=style&index=0&id=212b4e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212b4e28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
